import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26a2d97e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import ActuatorInput from '../Inputs/ActuatorInput'
import PhalanxInput from '../Inputs/PhalanxInput'
import { getFancyPhalanx, getFancyActuator } from '../utils'
import { inject, ref, provide, computed } from 'vue'
import MicrogestureComponent from '../MicrogestureComponent'


export default {
  __name: 'VariablesComponent',
  props: { modelValue: { } },
  emits: ['update:modelValue', 'delete'],
  setup(__props, { emit: emits }) {

const props = __props;





const inConstruction = inject('inConstruction', false)

const microgesture = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emits('update:modelValue', value)
  }
})
const displayedPicker = ref(undefined)
const selectedActuatorVariable = ref(0)
const selectedPhalanxVariable = ref(0)

provide('upperLevelType', microgesture.value.type)

function destroy (type, i) {
  microgesture.value.quantificators[type] =
    [...microgesture.value.quantificators[type].slice(0, i),
      ...microgesture.value.quantificators[type].slice(i + 1)
    ]
  if (microgesture.value.quantificators[type].length === 0) {
    delete microgesture.value.quantificators[type]
  }
  if (Object.keys(microgesture.value.quantificators).length === 0) {
    emits('update:modelValue', microgesture.value.seq)
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", {
      onDragstart: _cache[6] || (_cache[6] = $event => (_ctx.startDrag($event))),
      draggable: ""
    }, [
      (_unref(microgesture).quantificators.x)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(microgesture).quantificators.x.entries(), ([i, x]) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (x.length || _unref(inConstruction))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" x"),
                      (_unref(microgesture).quantificators.x.length > 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(i), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      _createTextVNode(" ∈ { "),
                      (_openBlock(), _createElementBlock("span", {
                        class: "plus-button",
                        onClick:  () => {
                  displayedPicker.value = (_unref(inConstruction)) ? 'actuator' : undefined;
                  selectedActuatorVariable.value = i
                }
                ,
                        key: i
                      }, _toDisplayString(_unref(getFancyActuator)(x, _unref(inConstruction))), 9, _hoisted_1)),
                      _createTextVNode(" }, ")
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256)),
            (displayedPicker.value === 'actuator')
              ? (_openBlock(), _createBlock(_unref(ActuatorInput), {
                  key: 0,
                  modelValue: _unref(microgesture).quantificators.x[selectedActuatorVariable.value],
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(microgesture).quantificators.x[selectedActuatorVariable.value]) = $event)),
                  onClose: _cache[1] || (_cache[1] = $event => (displayedPicker.value = null)),
                  "can-destroy": true,
                  onDestroy: _cache[2] || (_cache[2] = $event => (destroy('x', selectedActuatorVariable.value)))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _hoisted_2,
      (_unref(microgesture).quantificators.y)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(microgesture).quantificators.y.entries(), ([i, y]) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (y.length || _unref(inConstruction))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" y"),
                      (_unref(microgesture).quantificators.y.length > 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(i), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      _createTextVNode(" ∈ { "),
                      (_openBlock(), _createElementBlock("span", {
                        class: "plus-button",
                        onClick:  () => {
                  displayedPicker.value = (_unref(inConstruction)) ? 'phalanx' : undefined;
                  selectedPhalanxVariable.value = i
                }
                ,
                        key: `phalanx-${i}`
                      }, _toDisplayString(_unref(getFancyPhalanx)(y, _unref(inConstruction))), 9, _hoisted_3)),
                      _createTextVNode(" }, ")
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256)),
            (displayedPicker.value === 'phalanx')
              ? (_openBlock(), _createBlock(_unref(PhalanxInput), {
                  key: 0,
                  modelValue: _unref(microgesture).quantificators.y[selectedPhalanxVariable.value],
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_unref(microgesture).quantificators.y[selectedPhalanxVariable.value]) = $event)),
                  onClose: _cache[4] || (_cache[4] = $event => (displayedPicker.value = null)),
                  "can-destroy": true,
                  onDestroy: _cache[5] || (_cache[5] = $event => (destroy('y', selectedPhalanxVariable.value)))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ], 32),
    _hoisted_4,
    _createVNode(_unref(MicrogestureComponent), {
      modelValue: _unref(microgesture).seq,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_unref(microgesture).seq) = $event)),
      onDelete: _cache[8] || (_cache[8] = (id)=>emits('delete', id))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

}